import { useTheme } from '@chakra-ui/react';
import React from 'react'
import assets26trayecto from '../../../innerAsstes/Seccion trayecto/Recurso 26trayecto.png';
import { useAppContext } from '../../../App';
import ButtonMore from '../../buttonMore/buttonMore';

export default function SlideCourses() {
  const theme = useTheme();
  const {isMobile} = useAppContext();
    const style = styles(theme, isMobile);
    return (
      <div style={style.textAndImgContainer} className="sansation-bold">
        <div style={style.textContainer}>
          <p style={style.blueText}>
            MÁS DE 130 CURSOS ONLINE.
          </p>
          <p
            style={style.whiteText}>
            A TUS TIEMPOS,
          </p>
          <p style={style.whiteText2}>
            CON CERTIFICACIÓN
          </p>
          <p style={style.whiteText3}>
            NACIONAL E INTERNACIONAL
          </p>
          <ButtonMore customStyles={{
            container:{
              width: isMobile? '60%':'20%',
              padding: '0.5rem'
            }
          }}/>
        </div>
        <img style={style.imageContainer} src={assets26trayecto} alt="" />
      </div>
    );
  };
    
  const styles = (theme, isMobile) => ({
    textAndImgContainer: {
      display: "flex",
      flexDirection: isMobile? "column-reverse":"row",
      // width: '100%',
      justifyContent: "space-between",
      alignContent: "space-between",
    },
    textContainer: {
      // width: '100%'
    },
    imageContainer: {
      // width: '40%'
    },
    whiteText: {
      lineHeight: 1,
      paddingLeft: '1rem',
      fontSize: isMobile? "1.5rem":"5rem",
      color: theme.color.text.primary,
    },
    whiteText2: {
      lineHeight: 1.2,
      paddingLeft: '1rem',
      width: isMobile? "100%":'80%',
      fontSize: isMobile? "1.5rem":"3rem",
      color: theme.color.text.primary,
      backgroundColor: theme.background.tertiary
    },
    whiteText3: {
      lineHeight: 1.2,
      paddingLeft: '1rem',
      width: isMobile? "100%":'80%',
      fontSize: isMobile? "1.rem":"2rem",
      marginBottom: '1rem',
      color: theme.color.text.primary,
      backgroundColor: theme.background.tertiary
    },
    blueText: {
      lineHeight: 1,
      paddingLeft: '1rem',
      // width: isMobile? "100%":'30vw',
      fontSize: isMobile? "2rem":'3rem',
      color: theme.color.text.secondary,
    },
  });
